import { render, staticRenderFns } from "./GiftInDelivery.vue?vue&type=template&id=029599d6&scoped=true&"
import script from "./GiftInDelivery.vue?vue&type=script&lang=ts&"
export * from "./GiftInDelivery.vue?vue&type=script&lang=ts&"
import style0 from "./GiftInDelivery.vue?vue&type=style&index=0&id=029599d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029599d6",
  null
  
)

export default component.exports